import { render } from "./ChatComposer.vue?vue&type=template&id=730c2682&scoped=true"
import script from "./ChatComposer.vue?vue&type=script&lang=js"
export * from "./ChatComposer.vue?vue&type=script&lang=js"

import "./ChatComposer.vue?vue&type=style&index=0&id=730c2682&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730c2682"]])

export default __exports__